import {
    BDX_CURRENCY_TYPES
  } from '@constants'
import { sortBy } from 'lodash'

export const CashCallManagementTableColumns = [
{
    key: 'Status',
    label: 'STATUS',
    sortable: true,
    searchable: true,
    options: [{
      text: 'Draft',
      value: 'DRAFT'
    },
    {
      text: 'Saved',
      value: 'SAVED'
    },
    {
      text: 'Submitted',
      value: 'SUBMITTED'
    },
    {
      text: 'Rejected',
      value: 'REJECTED'
    },
    {
      text: 'Paid',
      value: 'PAID'
    },
    {
      text: 'Cancelled',
      value: 'CANCELLED'
    }
  ],
    width: 110,
},
{
  key: 'status_comment',
  label: 'Status Comments',
  sortable: true,
  searchable: true,
  width: 215,
},
{
  key: 'cash_call_comments',
  label: 'Cash Call Comments',
  sortable: true,
  searchable: true,
  width: 235,
},
// {
//   key: "status_actions",
//   label: "Status Action",
//   sortable: false,
//   thStyle: { width: "160px", textAlign: "center" }
// },
{
  key: 'created_on',
  label: 'CREATED DATE',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 160
},
{
  key: 'Created_By',
  label: 'Created By',
  sortable: true,
  searchable: true,
  width: 150,
},
{
  key: 'tpa_approvers',
  label: 'TPA Approver',
  sortable: true,
  searchable: true,
  width: 150,
},
{
  key: 'cash_call_reference',
  label: 'Reference',
  sortable: true,
  searchable: true,
  width: 170,
},
{
  key: 'Bdx_Key',
  label: 'LimeIQ Key',
  sortable: true,
  searchable: true,
  width: 290,
},
{
  key: 'Claim_Reference',
  label: 'Claim Ref',
  sortable: true,
  searchable: true,
  width: 150,
},  
{
  key: 'TPA',
  label: 'TPA',
  sortable: true,
  searchable: true,
  width: 120,
},
{
  key: 'Broker',
  label: 'Broker',
  sortable: true,
  searchable: true,
  width: 120,
}, 
{
  key: 'Lead_Underwriter',
  label: 'Lead Underwriter',
  sortable: true,
  searchable: true,
  width: 210,
}, 
{
  key: 'Insured_Name',
  label: 'Insured Name',
  sortable: true,
  searchable: true,
  width: 170,
}, 
{
  key: 'Cash_Call_Request_Amount',
  label: 'Requested Amount',
  width: 210,
  sortable: true,
  searchable: true
},
{
  key: 'Paid_Amount',
  label: 'Paid Amount',
  width: 190,
  sortable: true,
  searchable: true
},  
{
  key: 'Total_Indemnity_Amount',
  label: 'Indemnity',
  width:150,
  sortable: true,
  searchable: true
},
  
{
  key: 'Total_Fee_Amount',
  label: 'Total Fees',
  width: 155,
  sortable: true,
  searchable: true
},  
{
  key: 'TPA_Fees_Amount',
  label: 'TPA Fees',
  width: 120,
  sortable: false,
  searchable: true
},
{
  key: 'Adjusters_Fees_Amount',
  label: 'Adjuster Fees',
  width: 170,
  sortable: false,
  searchable: true
},  
{
  key: 'Defence_Fees_Amount',
  label: 'Defence Fees',
  width: 165,
  sortable: true,
  searchable: true
},  
{
  key: 'Expenses_Amount',
  label: 'Expenses',
  width: 145,
  sortable: true,
  searchable: true
},
{
  key: 'Attorney_Coverage_Amount',
  label: 'Attorney Coverage',
  width: 225,
  sortable: true,
  searchable: true
},
{
  key: 'recipient_emails',
  label: 'Recipients',
  sortable: true,
  searchable: true,
  width: 170
},
{
  key: 'submitted_on',
  label: 'SUBMITTED DATE',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 170
},
{
  key: 'paid_on',
  label: 'PAID DATE',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 130
},
{
  key: 'cancelled_on',
  label: 'CANCELLED DATE',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 170
},
{
  key: 'rejected_on',
  label: 'REJECTED DATE',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 160
},
]